import { useLocation } from '@reach/router'
import { locationMatches } from '@src/helpers/abTests'
import { mixpanelService } from '@src/srv/mixpanel.service'
import { selectAssignments } from '@src/store/experiment/experiment.slice'
import { useEffect } from 'react'
import { useAppSelector } from './useAppSelector'

/**
 * Fires non-dev experiments impressions
 */
export function useNonDevExperimentImpression(): void {
  const assignments = useAppSelector(selectAssignments)
  const location = useLocation()

  useEffect(() => {
    if (assignments == null) {
      return
    }

    for (const expId in assignments) {
      if (!assignments[expId]?.data) continue
      const { impressionPage } = assignments[expId].data
      if (!locationMatches(location.pathname, impressionPage)) continue
      mixpanelService.testImpression(expId, assignments[expId].bucket)
      console.log(`Impression logged for experiment ${expId} in group ${assignments[expId].bucket}`)
    }
  }, [assignments, location])
}
